import { parseNetworkErrorResponse as apolloError } from '@waybetter/apollo-error';

/**
 * Takes an error response from a server and transforms it into a signature
 * that matches the expected apollo errors to be easily parsed.
 *
 * @param {object} error - An error response from a server call.
 * @returns {object} Returns the parsed errors including a  human readable
 * error.
 */
export const parseNetworkErrorResponse = (error) =>
  apolloError({ networkError: { result: error } });
